import { gql } from '@common/hooks';

const CreateWorksSubmittalPacket = gql`
  mutation CreateWorksSubmittalPacket($worksProfileId: ID!, $file: Upload!) {
    createWorksSubmittalPacket(worksProfileId: $worksProfileId, file: $file) {
      worksSubmittalPacket {
        id
        files {
          id
        }
      }
    }
  }
`;

export { CreateWorksSubmittalPacket };
